const PERMISSION_KEY = "personalize:nebula_ultra_plan";
const PAGE_URL = {
    NEBULA_ULTRA_PLAN_PAGE: "/admin/personalize/nebula-ultra-plan"
};
export { PERMISSION_KEY, PAGE_URL };
